import React from "react";
import {
  HeaderScrolledContainer,
  HeaderRow,
  HeaderScrolledLeft,
  HeaderScrolledRight,
  TagsGroup,
  TagSeparator,
} from "./HeaderScrolled.styled";
import { Avatar, Typography, Button, Icon, Tag } from "@ann/web-components";
import { useContactHeader } from "../../hooks/useContactHeader";
import { generateMockAvatarUrl } from "../../../../../utils/avatarUtils";

const HeaderScrolled = ({ onChatClick }) => {
  const { contactDetails, loading, hasContact } = useContactHeader();

  if (!hasContact || !contactDetails || loading) {
    return null;
  }

  const { name, role, company, ownerName } = contactDetails;
  const avatarSrc = generateMockAvatarUrl(name) || "https://i.pravatar.cc/32";

  return (
    <HeaderScrolledContainer>
      <HeaderRow>
        <HeaderScrolledLeft>
          <Avatar
            alt={name || "Default avatar"}
            size="lg"
            src={avatarSrc}
          />
          <TagsGroup>
            <Typography category="subtitle" weight="bold" size="small" color="title">
              {name}
            </Typography>
            <TagSeparator>•</TagSeparator>
            <Icon name="adminPanelSettings" size="small" color="neutral" />
            <Typography category="body" weight="regular" size="small" color="body">
              {role}
            </Typography>
            <TagSeparator>•</TagSeparator>
                <Icon name="work" size="small" color="neutral" />
            <Typography category="body" weight="regular" size="small" color="body">
              {company}
            </Typography>
            <TagSeparator>•</TagSeparator>
            <Typography category="body" weight="regular" size="small" color="body">
              {ownerName}
            </Typography>
            <TagSeparator>•</TagSeparator>
            <Tag
              color="informative"
              onClick={() => {}}
              onClose={() => {}}
              size="medium"
              text="Appointment Today"
            />
          </TagsGroup>
        </HeaderScrolledLeft>
        <HeaderScrolledRight>
          <Button
            icon="aiChat"
            label=""
            size="small"
            type="gradient"
            onClick={() => onChatClick?.()}
          />
          <Icon name="chevronRight" size="medium" color="neutral" />
        </HeaderScrolledRight>
      </HeaderRow>
    </HeaderScrolledContainer>
  );
};

export default HeaderScrolled;
